/*
 * 澎湃新闻 - 热榜（服务端路由）
 */
export async function fetchThepaperHot() {
  const res = await fetch('/server-api/thepaper')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
